import { createModelStore } from '@/shared/stores/create-model-store'
import { model10InitialModel } from './initial-state'
import { model10DimensionHandlers } from './dimensions'

export const useModel10Store = createModelStore({
  initialModel: model10InitialModel,
  dimensionHandlers: model10DimensionHandlers,
})
